import script from "./update-card.vue?vue&type=script&setup=true&lang=js"
export * from "./update-card.vue?vue&type=script&setup=true&lang=js"

import "./update-card.vue?vue&type=style&index=0&id=dfe47424&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfe47424"]])

export default __exports__